<template>
  <modal
    ref="blockModal"
    :canBeDismissed="false"
    :topMargin="isMobile() ? '50vh' : ''"
  >
    <template slot="body">
      <div class="d-flex flex-column px-3">


      <h2>{{ getAlertTitle }}</h2>
      <div  v-html="getAlert"></div>
      <button class="btn btn-light" @click="confirm">ok</button>
      </div>
      </template>
  </modal>
</template>

<script>
  import modal from "../modal.vue";
  import { mapGetters } from "vuex";
  export default {
    components: {
      modal,
    },
    props: {
      remainingTime: {
        type: Object,
      },
      hideBlockModel: {
        type: Function,
      }
    },
    computed: {
      ...mapGetters(["selectedCompany"]),
      getAlert() {
        // BlockTimePopupDescription
        let alert = this.selectedCompany.ViewComponentConfigs && this.selectedCompany.ViewComponentConfigs.BlockTimeEnabled
            ? this.selectedCompany.ViewComponentConfigs.BlockTimePopupDescription
            : "<p><Block Time Alert</p>";
        alert += `<br><p>Remaining Time: ${this.remainingTime.minutes} minutes and ${this.remainingTime.seconds} seconds</p>`;
        return alert;
      },
      getAlertTitle() {
        return this.selectedCompany.ViewComponentConfigs && this.selectedCompany.ViewComponentConfigs.BlockTimeEnabled
            ? this.selectedCompany.ViewComponentConfigs.BlockTimePopupTitle
            : "Block Time Alert";
      },
    },
    methods: {
      confirm() {
        this.hideBlockModel();
        this.$refs.blockModal.hideModal(true);
      },
    },
  };
</script>

